import React from 'react';
import { IconType } from 'react-icons';
import styled from 'styled-components';
import { RhInputDiv, RhInputMode } from './RhInput';
import { colors } from './Styles';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** from react-icons package */
  icon?: IconType;
  /** input mode  */
  mode?: RhInputMode;
  /** container style */
  containerStyle?: React.CSSProperties;
}

export const RhTextArea: React.FC<Props> = ({ icon: Icon, mode = RhInputMode.bordered, containerStyle, ...rest }) => {
  return (
    <RhInputDiv mode={mode} style={containerStyle}>
      {Icon && <Icon color={colors.grey} />} <Input {...rest} />
    </RhInputDiv>
  );
};

const Input = styled.textarea`
  all: unset;
  // but just to be sure:
  appearance: none;
  outline: none;
  border: none;

  font-weight: 600;
  font-size: 16px;
  width: 100%;
`;
